import { PrimaryButton, SecondaryButton } from '../components/Buttons';
import { ErrorMessage } from '../components/ErrorMessage';
import { BrandMark } from '../components/BrandMark';

interface SendScreenProps {
  onSubmit: () => void;
  onBack: () => void;
  sending: boolean;
  error: string | null;
  honeypot: string;
  setHoneypot: (value: string) => void;
}

// Envío (handoff §11.4). Incluye campo trampa anti-bots (honeypot) oculto.
export function SendScreen({
  onSubmit,
  onBack,
  sending,
  error,
  honeypot,
  setHoneypot,
}: SendScreenProps) {
  return (
    <main className="gb-screen gb-screen--question">
      <section className="gb-card gb-anim">
        <p className="gb-card__eyebrow">Último paso</p>
        <h1 className="gb-card__question">Todo listo. ¿Enviamos tus respuestas?</h1>
        <p className="gb-card__help">
          Antes de enviar puedes volver atrás y revisar cualquier respuesta. Una vez enviadas, se
          procesan de forma anónima y agregada.
        </p>

        {/* Honeypot: invisible para personas; los bots tienden a rellenarlo. */}
        <div aria-hidden="true" className="gb-visually-hidden">
          <label>
            No completar este campo
            <input
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
            />
          </label>
        </div>

        {sending ? (
          <div className="gb-sending" role="status">
            <span className="gb-brandloader">
              <span className="gb-brandloader__ring" aria-hidden="true" />
              <BrandMark className="gb-brand--pulse" />
            </span>
            <p className="gb-sending__text">Guardando tus respuestas…</p>
          </div>
        ) : (
          <>
            <ErrorMessage>{error}</ErrorMessage>
            <div className="gb-card__nav">
              <SecondaryButton onClick={onBack}>Atrás</SecondaryButton>
              <PrimaryButton onClick={onSubmit}>
                {error ? 'Reintentar enviar' : 'Enviar mis respuestas'}
              </PrimaryButton>
            </div>
          </>
        )}
      </section>
    </main>
  );
}
